import { render, staticRenderFns } from "./user-table.vue?vue&type=template&id=0a090543&scoped=true"
import script from "./user-table.vue?vue&type=script&lang=js"
export * from "./user-table.vue?vue&type=script&lang=js"
import style0 from "./user-table.vue?vue&type=style&index=0&id=0a090543&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a090543",
  null
  
)

export default component.exports